import type { PriorityQueue } from "common/data/priorityQueue";
import type { DebugPoint2Options, DebugPolyLine2Options, DebugTextOptions } from "../debugTypes";
import type { PolyLine2 } from "../polyLine2Types";
import type { Vec2 } from "../vec2";

export enum SkeletonError {
  POLYLINE_INVALID = "POLYLINE_INVALID",
  OFFSET_INVALID = "OFFSET_INVALID",
  NAN_VALUE = "NAN_VALUE",
  ZERO_LENGTH_EDGE = "ZERO_LENGTH_EDGE",
  ITERATION_LIMIT_REACHED = "ITERATION_LIMIT_REACHED",
}

export interface SkeletonConfig {
  /**
   * maps the edges in an input polyLine to edges in an output polyLine.
   * in the event that an edge in the input polyLine goes away, it may map
   * to adjacent edges in the output polyLine.
   */
  oldToNew?: { [key: number]: number[] };
  /**
   * maps the edges in the output polyLine to edges in the input polyLine
   */
  newToOld?: number[];
  epsilon?: number;
  debug?: {
    log?: string[];
    text?: DebugTextOptions[];
    points?: DebugPoint2Options[];
    lines?: DebugPolyLine2Options[];
  };
  iterationLimit?: number;
  /**
   * Useful if input PolyLine is messy or malformed, however this will also
   * change the indices of the edges in the input PolyLine.
   */
  repairZeroLengthEdges?: boolean;
}

export type EdgeSpeeds = number | number[];

export interface SkeletonEvent {
  id: number;
  time: number;
  position: Vec2;
  incoming: SkeletonLine[];
  // @TODO(ANDREW): this should be calculated based on the number of incoming lines
  valid: boolean;
}

export interface SkeletonLine {
  id: number;
  start: SkeletonEvent;
  dir: Vec2;
  neighbors: SkeletonLine[];
  edges: number[];
  infiniteSpeed: boolean;
  queue: PriorityQueue<SkeletonEvent>;
}

export interface StraightSkeletonResult {
  success: boolean;
  errors?: SkeletonError[];
  pls: PolyLine2[];
}
